import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { requestFail, requestError } from '@jms/utils'
import { useAuthStore, useSettingStore, useSysDataStore } from '@jms/store'
import { objKeySort, deleteNullKey } from '@jms/utils/index'
// import LangType from '@jms/utils/enums/LangType'
// import { GlobalEnum } from '@jms/utils/enums'
// import { encrypt, decrypt } from '@jms/utils/signKey'
import { Md5 } from 'ts-md5'
import HTTP_CODE_STATUS from '@jms/utils/httpCode'
import LangType from '@jms/utils/enums/LangType'
const { VITE_APP_API_BASE_URL, VITE_APP_ASDFGHJKL, VITE_APP_QWERTYUIOP } = import.meta.env
export const getToken = () => {
  const authStore = useAuthStore()
  return authStore?.token
}
const tran = {
  zh: 'CN',
  hk: 'HK',
  en: 'EN',
  my: 'MY',
  id: 'ID'
}
// const excludeList = ['captcha/get', '/captcha/check']
const excludeList = []
/**获取验签 */
const getTmpSign = (config: AxiosRequestConfig, _time: any) => {
  /**删除空值 */
  let params = deleteNullKey(config.data ? JSON.parse(config.data) : {})
  if (config.method === 'get') params = config.params ?? {}
  /**排序 */
  params = objKeySort(params)
  // const reg = new RegExp('"', 'g')
  const reg2 = new RegExp(`'\''`, 'g')
  const key = `${JSON.stringify(params)}${_time}`.replaceAll(reg2, '')
  return Md5.hashStr(key)
}
// 设置请求头和请求路径
axios.defaults.baseURL = VITE_APP_API_BASE_URL
if (process.env.NODE_ENV !== 'production') {
  axios.defaults.baseURL = (localStorage.getItem('localIp') as string) || VITE_APP_API_BASE_URL
}
axios.defaults.timeout = 15000
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    config.baseURL += ''
    const { locale } = useSettingStore()
    const _time = new Date().getTime()
    if (config.method === 'get') {
      const data = config.params || {}
      config.data = JSON.stringify(data)
    }
    if (!(excludeList.indexOf(config.url as string) > -1)) {
      Object.assign(config.headers!, {
        authorization: getToken(),
        timestamp: _time,
        language: tran[locale],
        langType: tran[locale],
        source: 'boxAdmin',
        sign: getTmpSign(config, _time)
      })
      // 序列化
      // const data = config.data
      // config.data = {
      //   data
      // }
      // console.log('data :>> ', data)
      // config.headers['sign'] = Md5.hashStr(data + _time)
    }

    return config
  },
  (error) => {
    return error
  }
)
// 响应拦截
axios.interceptors.response.use(
  (res: AxiosResponse) => {
    if (res.status === 200) {
      const { data } = res
      const SUCCESS_CODES = [
        HTTP_CODE_STATUS.SUCCESS,
        // HTTP_CODE_STATUS.JTS_UPLOAD_SUCCESS,
        HTTP_CODE_STATUS.TIME_BACK_STATUS
        // HTTP_CODE_STATUS.JTS_SUCCESS
      ]
      if (data?.code && !SUCCESS_CODES.includes(data.code)) requestFail(data)
    }
    return res
  },
  (err: AxiosError) => {
    requestError(err)
  }
)
export default axios
